<template>
  <div
    class="product-compliance"
    id="product-compliance"
  >
    <accordion
      ref="accordion"
      class="product-compliance__accordion"
      :is-content-html="true"
      id="product-compliance-details"
      :name="$t('ads.main.compliance.section.name')"
    >
      <div
        slot="content"
        class="product-compliance__content"
      >
        <ul class="product-compliance__list">
          <li
            v-for="(document, index) in compliance"
            :key="index"
            class="product-compliance__item"
          >
            <a
              v-if="document.href"
              :href="document.href"
              class="product-compliance__link"
              target="_blank"
              rel="noopener noreferrer"
            >{{ document.name }}</a>
            <span
              v-else
              class="product-compliance__name"
            >{{ document.name }}</span>
          </li>
        </ul>
      </div>
    </accordion>
  </div>
</template>
<script>
import Accordion from '../accordion/accordion.vue'

const ProductComplianceAccordion = {
  name: 'product-compliance-accordion',
  components: {
    Accordion
  },
  props: {
    compliance: Array
  },
  methods: {
    openAccordion() {
      this.$refs.accordion.open()
    }
  }
}

export default ProductComplianceAccordion
</script>
